export enum RolesEnum {
    reveler = 'reveler',
    compnayAdmin = 'company-admin',
    user = 'user',
    liveAgent = 'agent',
    revelAgent = 'revel-agent'
}
